/* eslint no-shadow: ["error", { "allow": ["state"] }] */

const state = {
  items: [],
  colorsSelected: [],
  color: '#999999',
};

const actions = {};

const mutations = {
  // A no-op mutation must be added to serve as a trigger for a reset.
  reset: () => { },
  setColor(state, color) {
    state.color = color;
  },
  pickColor(state, color) {
    if (state.colorsSelected.indexOf(color) === -1) {
      if (state.colorsSelected.length > 9) {
        state.colorsSelected.pop();
      }
      state.colorsSelected.unshift(color);
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
